/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { CostumeInventoryProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "CostumeInventoryReportPageService";
const log: any = LoggerModule.getInstance();

export class CostumeInventoryReportPageService {
  private static instance: CostumeInventoryReportPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): CostumeInventoryReportPageService {
    if (!CostumeInventoryReportPageService.instance) {
      CostumeInventoryReportPageService.instance = new CostumeInventoryReportPageService(props);
    }
    return CostumeInventoryReportPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getSections(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    //getSections Props
    compProps = await agent.getSections({
      ...args
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateCostumeInventory(args: CostumeInventoryProps) {
    log.info(`costume Inventory service`, args);
    const agent = getAgent();
    return agent.updateCostumeInventory(args);
  }
  public async getSectionOptions(args: CostumeInventoryProps) {
    const agent = getAgent();
    return agent.getSectionOptionsProps(args);
  }
  public async getPresentations(args: CostumeInventoryProps) {
    const agent = getAgent();
    return agent.getPresentationsProps(args);
  }
  public async getAllSectionOptions(args: CostumeInventoryProps) {
    const agent = getAgent();
    return agent.getAllSectionOptions(args);
  }

}
